/* eslint-disable no-param-reassign */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';

import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import { differenceInYears, format, parse } from 'date-fns';
import { IoIosArrowBack } from 'react-icons/io';
import { useHistory, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import * as Yup from 'yup';

import {
  Input,
  Select,
  Layout,
  Textarea,
  InputMask,
  InputRadio,
} from '~/components';
import { useScreen } from '~/hooks/screen';
import { useStudent } from '~/hooks/student';
import api from '~/services/api';
import { formatProfileCode } from '~/utils/formatProfileCode';
import getValidationErrors from '~/utils/getValidationErrors';
import { imcCalc } from '~/utils/imcCalc';

import {
  studentLevelOptions,
  objectiveOptions,
  frequencyOptions,
  availableTimeOptions,
  scheduleOptions,
} from './constants';
import LeftSide from './LeftSide';
import RightSide from './RightSide';
import {
  DataSheet,
  SelectProps,
  SkinFoldData,
  SkinFoldFormData,
} from './types';
import { useSkinFoldState } from './useSkinFoldState';
import { getProfileCode } from './utils';

import { CheckBoxSide } from '../DataSheetRegister/styles';
import {
  Container,
  PageHeader,
  PageHeaderBackButton,
  PageHeaderBackButtonLabel,
  Sidebar,
  Wrapper,
  PageHeaderSaveButton,
  FormContainer,
  FormLineWrapper,
  FieldSet,
  Label,
  CheckboxWrapper,
  SectionLabel,
  DoubleInputContainer,
  SelectWrapper,
  RadioButton,
  ProfileCodeContainer,
  TextareaSet,
  SessionContainer,
} from './styles';

interface RouteParams {
  userId: string;
  dataSheetId: string;
}

export const inputStyle = {
  input: {
    height: 35,
    marginTop: 5,
    padding: '0 1.7rem',
  },
  textArea: {
    width: '100%',
    marginTop: 5,

    height: '19rem',
    padding: '2rem',
    borderRadius: '1rem',
  },
  doubleInput: {
    height: 35,
    marginTop: 5,

    padding: '0 1.7rem',
  },
  select: {
    placeholder: () => ({
      padding: '0 1rem',
      color: '#00000080',
    }),
    singleValue: () => ({
      padding: '0 1rem',
    }),
  },
};

const initialSkinFoldData: SkinFoldData = {
  id: 0,
  student_id: 0,
  professional_id: 0,
  gym_id: '',
  genre: '',
  classification: '',
  objective: '',
  student_level: '',
  frequency: '',
  available_time: '',
  training_division: '',
  week_days: '',
  health_history: '',
  injury_history: '',
  height: 0,
  weight: 0,
  goal_weight: 0,
  body_fat: 0,
  imc: 0,
  birth_date: '',
  circumference_chest: 0,
  circumference_waist: 0,
  circumference_abdomen: 0,
  circumference_hip: 0,
  skin_folds_total: 0,
  created_at: '',
  updated_at: '',
  time_preference: '',
  circumference_relaxed_arm_right: 0,
  circumference_relaxed_arm_left: 0,
  circumference_contracted_arm_right: 0,
  circumference_contracted_arm_left: 0,
  circumference_forearm_right: 0,
  circumference_forearm_left: 0,
  circumference_fist_right: 0,
  circumference_fist_left: 0,
  circumference_proximal_thigh_right: 0,
  circumference_proximal_thigh_left: 0,
  circumference_distal_thigh_right: 0,
  circumference_distal_thigh_left: 0,
  circumference_calf_right: 0,
  circumference_calf_left: 0,
  set_left_side: '',
  set_right_side: '',
  skin_folds_biceps_right: 0,
  skin_folds_biceps_left: 0,
  skin_folds_triceps_left: 0,
  skin_folds_triceps_right: 0,
  skin_folds_abdomen_left: 0,
  skin_folds_abdomen_right: 0,
  skin_folds_breastplate_left: 0,
  skin_folds_breastplate_right: 0,
  skin_folds_calf_left: 0,
  skin_folds_calf_right: 0,
  skin_folds_heigsupra_iliacaht_left: 0,
  skin_folds_heigsupra_iliacaht_right: 0,
  skin_folds_middle_armpit_left: 0,
  skin_folds_middle_armpit_right: 0,
  skin_folds_subscapular_left: 0,
  skin_folds_subscapular_right: 0,
  skin_folds_thigh_left: 0,
  skin_folds_thigh_right: 0,
  studentAge: 0,
  profile_code: '',
};

const DataSheetEdit: React.FC = () => {
  const { userId: studentId, dataSheetId } = useParams<RouteParams>();
  const { goBack } = useHistory();
  const { studentData, updateStudent } = useStudent();
  const { updateScreen } = useScreen();
  const { skinFoldData, updateAll, updateField } =
    useSkinFoldState(initialSkinFoldData);
  const formRef = useRef<FormHandles>(null);

  const [skinFoldSide, setSkinFoldSide] = useState<'left' | 'right'>('right');
  const [loading, setLoading] = useState<boolean>(false);
  const [selectedBox, setSelectedBox] = useState<string[]>(['SEGUNDA']);
  const [selectedComponent, setSelectedComponent] = useState('dataSheet');
  const [studentLevel, setStudentLevel] = useState<string>(
    studentLevelOptions[0].value,
  );
  const [defaultStudentLevel, setDefaultStudentLevel] = useState(
    {} as SelectProps,
  );
  const [frequency, setFrequency] = useState<string>(frequencyOptions[0].value);
  const [defaultFrequency, setDefaultFrequency] = useState({} as SelectProps);
  const [availableTime, setAvailableTime] = useState<string>(
    availableTimeOptions[0].value,
  );
  const [defaultAvailableTime, setDefaultAvailableTime] = useState({
    value: '',
  } as SelectProps);
  const [objective, setObjective] = useState<string>(objectiveOptions[0].value);
  const [defaultObjective, setDefaultObjective] = useState({} as SelectProps);
  const [defaultScheduleTime, setDefaultScheduleTime] = useState(
    {} as SelectProps,
  );
  const [scheduleTime, setScheduleTime] = useState<string>(
    scheduleOptions[0].value,
  );

  const studentAge = useMemo(() => {
    const date = parse(
      studentData.student.birth_date,
      'yyyy-mm-dd',
      new Date(),
    );

    const age = differenceInYears(new Date(), date);
    return age;
  }, [studentData]);

  // ? Pega os dados da ficha técnica a ser editada
  // ! Não colocar o updateAll como depedência, vira loop infinito
  const handleGetTechnicalSheetData = useCallback(async () => {
    const { data } = await api.get<DataSheet>(`datasheets/${dataSheetId}`);
    setSelectedBox([...data?.week_days.split(',')]);

    const filteredStudentLevel = studentLevelOptions.filter(
      (level) => level.value === data.student_level,
    )[0];

    const filteredFrequency = frequencyOptions.filter(
      (freq) => freq.value === data.frequency,
    )[0];

    const filteredAvailableTime = availableTimeOptions.filter(
      (time) => time.value === data.available_time,
    )[0];

    const filteredObjective = objectiveOptions.filter(
      (obj) => obj.value === data.objective,
    )[0];

    const filteredScheduleTime = scheduleOptions.filter(
      (schedule) => schedule.value === data.time_preference,
    )[0];

    setDefaultScheduleTime(filteredScheduleTime);

    setDefaultObjective(filteredObjective);
    setObjective(filteredObjective?.value);

    setDefaultAvailableTime(filteredAvailableTime);

    setDefaultFrequency(filteredFrequency);
    setFrequency(filteredFrequency?.value);
    // console.log('filteredFrequency:', data.frequency);

    setDefaultStudentLevel(filteredStudentLevel);

    setStudentLevel(filteredStudentLevel.value);

    const formData = {
      ...data,
      height:
        String(data.height).length === 3
          ? `${String(data.height).split('.').join()}0`
          : String(data.height).split('.').join(),
      weight:
        String(data.weight).length === 3
          ? `${String(data.weight).split('.').join()}0`
          : String(data.weight).split('.').join(),
      student_level: filteredStudentLevel?.value,
      profile_code: formatProfileCode(data.profile_code),
    };

    const { skin_folds_abdomen_left } = formData;
    if (skin_folds_abdomen_left) {
      setSkinFoldSide('left');
    } else {
      setSkinFoldSide('right');
    }

    const defaultData = {
      ...formData,
      studentAge,
    };

    updateAll(defaultData as unknown as SkinFoldData);
  }, [dataSheetId, studentAge]);

  // ? Carrega os dados da ficha técnica
  useEffect(() => {
    handleGetTechnicalSheetData();
  }, [handleGetTechnicalSheetData]);

  // ? Atualiza dados do aluno no hook caso não estejam lá
  useEffect(() => {
    updateStudent(studentId);
    updateScreen(`dataSheet`);
  }, [studentId, updateStudent, updateScreen]);

  // ? Update do imc
  useEffect(() => {
    const { height, weight } = skinFoldData;
    const heightAsNumber = parseFloat(String(height).replaceAll(',', '.'));
    const weightAsNumber = parseFloat(String(weight).replaceAll(',', '.'));

    const newIMC = imcCalc({
      h: heightAsNumber || ``,
      w: weightAsNumber || ``,
    });

    updateField('imc', newIMC.imc);
    updateField('classification', newIMC.classification);
  }, [skinFoldData.height, skinFoldData.weight]);

  // ? Update do profileCode
  // ! Não colocar o updateField como depedência, vira loop infinito
  useEffect(() => {
    const profile_code = getProfileCode({
      studentLevel,
      frequency,
      gender: studentData?.student?.genre,
      availableTime,
      physicalEvaluation: skinFoldData?.classification || '',
      objective,
    });

    const formattedProfileCode = formatProfileCode(profile_code);
    updateField('profile_code', formattedProfileCode);
  }, [
    studentLevel,
    frequency,
    studentData,
    availableTime,
    objective,
    skinFoldData.classification,
    skinFoldData.profile_code,
  ]);

  const checkBoxOptions = useMemo(() => {
    return [
      { id: 'SEGUNDA', label: 'Segunda' },
      { id: 'TERÇA', label: 'Terça' },
      { id: 'QUARTA', label: 'Quarta' },
      { id: 'QUINTA', label: 'Quinta' },
      { id: 'SEXTA', label: 'Sexta' },
      { id: 'SABADO', label: 'Sábado' },
      { id: 'DOMINGO', label: 'Domingo' },
    ];
  }, []);

  const handleSelectedCheckbox = useCallback(
    (id: string) => {
      console.log('render 7');
      const frequencyValue = parseInt(frequency.split('')[0], 10);

      if (selectedBox.includes(id) && selectedBox.length === 1) return;

      if (selectedBox.length === 1 && frequencyValue === 1) {
        setSelectedBox([id]);
        return;
      }

      if (selectedBox.length < frequencyValue) {
        const newValues = [];

        if (selectedBox.includes(id) && selectedBox.length < frequencyValue) {
          let valuesWithOldArray = [...selectedBox];

          const filteredValues = selectedBox.filter((item) => item !== id);
          valuesWithOldArray = filteredValues;

          setSelectedBox(valuesWithOldArray as string[]);
        } else {
          selectedBox.includes(id)
            ? newValues.push(...[selectedBox.filter((item) => item !== id)])
            : newValues.push(...[...selectedBox, id]);

          setSelectedBox(newValues as string[]);
        }
      } else {
        let valuesWithOldArray2 = [...selectedBox];

        if (selectedBox.includes(id)) {
          const filteredValues = selectedBox.filter((item) => item !== id);
          valuesWithOldArray2 = filteredValues;
        }

        setSelectedBox(valuesWithOldArray2 as string[]);
      }
    },
    [selectedBox, frequency],
  );

  const CheckBox = useMemo(
    () =>
      checkBoxOptions.map((item) => (
        <RadioButton
          key={item.id}
          isSelected={selectedBox.includes(item.id)}
          onClick={() => handleSelectedCheckbox(item.id)}
        >
          <div className="radio">
            <div className="filled" />
          </div>

          <p>{item.label}</p>
        </RadioButton>
      )),
    [checkBoxOptions, selectedBox, handleSelectedCheckbox],
  );

  const handleSubmit = useCallback(
    async (data: DataSheet) => {
      setLoading(true);

      const formData: SkinFoldFormData = {
        ...skinFoldData,
        frequency,
        circumference_chest: skinFoldData.circumference_chest,
        circumference_waist: skinFoldData.circumference_waist,
        circumference_abdomen: skinFoldData.circumference_abdomen,
        circumference_hip: skinFoldData.circumference_hip,
        circumference_relaxed_arm_right:
          skinFoldData.circumference_relaxed_arm_right,
        circumference_relaxed_arm_left:
          skinFoldData.circumference_relaxed_arm_left,
        circumference_contracted_arm_right:
          skinFoldData.circumference_contracted_arm_right,
        circumference_contracted_arm_left:
          skinFoldData.circumference_contracted_arm_left,
        circumference_forearm_right: skinFoldData.circumference_forearm_right,
        circumference_forearm_left: skinFoldData.circumference_forearm_left,
        circumference_fist_right: skinFoldData.circumference_fist_right,
        circumference_fist_left: skinFoldData.circumference_fist_left,
        circumference_proximal_thigh_right:
          skinFoldData.circumference_proximal_thigh_right,
        circumference_proximal_thigh_left:
          skinFoldData.circumference_proximal_thigh_left,
        circumference_distal_thigh_right:
          skinFoldData.circumference_distal_thigh_right,
        circumference_distal_thigh_left:
          skinFoldData.circumference_distal_thigh_right,
        circumference_calf_right: skinFoldData.circumference_calf_right,
        circumference_calf_left: skinFoldData.circumference_calf_left,
        objective,
        time_preference: scheduleTime,
        available_time: availableTime,
        height: Number(String(skinFoldData.height).replace(',', '.')),
        weight: Number(String(skinFoldData.weight).replace(',', '.')),
        student_level: studentLevel,
        student_id: parseInt(studentId, 10),
        birth_date: format(
          new Date(studentData?.student?.birth_date),
          'yyyy-MM-dd',
        ),
        week_days: selectedBox.join(','),
        health_history:
          skinFoldData.health_history ||
          'Prefiro não incluir histórico de saúde',
        injury_history:
          skinFoldData.injury_history ||
          'Prefiro não incluir histórico de lesão',
        skin_folds_total: data.skin_folds_total,
      };

      if (skinFoldSide === 'left') {
        formData.skin_folds_abdomen_left = data.skin_folds_abdomen_left;
        formData.skin_folds_biceps_left = data.skin_folds_biceps_left;
        formData.skin_folds_breastplate_left = data.skin_folds_breastplate_left;
        formData.skin_folds_calf_left = data.skin_folds_calf_left;
        formData.skin_folds_heigsupra_iliacaht_left =
          data.skin_folds_heigsupra_iliacaht_left;
        formData.skin_folds_middle_armpit_left =
          data.skin_folds_middle_armpit_left;
        formData.skin_folds_subscapular_left = data.skin_folds_subscapular_left;
        formData.skin_folds_thigh_left = data.skin_folds_thigh_left;
        formData.skin_folds_triceps_left = data.skin_folds_triceps_left;
      } else {
        formData.skin_folds_abdomen_right = data.skin_folds_abdomen_right;
        formData.skin_folds_biceps_right = data.skin_folds_biceps_right;
        formData.skin_folds_breastplate_right =
          data.skin_folds_breastplate_right;
        formData.skin_folds_calf_right = data.skin_folds_calf_right;
        formData.skin_folds_heigsupra_iliacaht_right =
          data.skin_folds_heigsupra_iliacaht_right;
        formData.skin_folds_middle_armpit_right =
          data.skin_folds_middle_armpit_right;
        formData.skin_folds_subscapular_right =
          data.skin_folds_subscapular_right;
        formData.skin_folds_thigh_right = data.skin_folds_thigh_right;
        formData.skin_folds_triceps_right = data.skin_folds_triceps_right;
      }

      delete formData.set_left_side;
      delete formData.set_right_side;
      delete formData.studentAge;

      const schema = Yup.object().shape({
        student_id: Yup.number().required(),
        birth_date: Yup.string().required(),
        height: Yup.number().required('O campo é obrigatório!'),
        weight: Yup.number().required('O campo é obrigatório'),
        imc: Yup.number().required('O campo é obrigatório'),
        body_fat: Yup.number().required('O campo é obrigatório'),
        goal_weight: Yup.number().required('O campo é obrigatório'),
      });
      console.log('Form:', formData);
      try {
        await schema.validate(formData, { abortEarly: false });

        await api.put(`datasheets/${dataSheetId}`, formData);

        toast.success('Ficha técnica editada com sucesso!');

        setLoading(false);
        goBack();
      } catch (err) {
        console.log(err);
        setLoading(false);

        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);

          formRef.current?.setErrors(errors);
        }

        toast.error('Erro ao editar ficha técnica!');
      }
    },
    [
      skinFoldData,
      studentId,
      frequency,
      scheduleTime,
      objective,
      dataSheetId,
      availableTime,
      studentData,
      selectedBox,
      goBack,
      skinFoldSide,
    ],
  );

  const handleInputChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const sanitizedValue = event.target.value
        .replace(/[^0-9.,]/g, '')
        .replaceAll('.', ',');
      event.target.value = sanitizedValue;
    },
    [],
  );

  const sidebarList = [
    {
      value: 'dataSheet',
      title: 'Ficha técnica',
    },
    {
      value: 'anthropometry',
      title: 'Antropometria',
    },
  ];

  const renderSkinFoldSide = useCallback(() => {
    return (
      <SectionLabel secondary>
        dobras cutâneas
        <CheckBoxSide>
          <section>
            <InputRadio
              name="set_left_side"
              id="set_left_side"
              checked={skinFoldSide === 'left'}
              onClick={() => setSkinFoldSide('left')}
            />
            <label>Lado esquerdo</label>
          </section>

          <section>
            <InputRadio
              name="set_right_side"
              id="set_right_side"
              checked={skinFoldSide === 'right'}
              onClick={() => setSkinFoldSide('right')}
            />
            <label>Lado direito</label>
          </section>
        </CheckBoxSide>
      </SectionLabel>
    );
  }, [skinFoldSide]);

  const renderDataSheetForm = useCallback(() => {
    return (
      selectedComponent === 'dataSheet' && (
        <>
          <FormContainer>
            <FieldSet>
              <Label>Altura:</Label>
              <InputMask
                mask="9,99"
                name="height"
                placeholder="1,75"
                containerStyle={inputStyle.input}
                fontSize="1.5rem"
                type="text"
                value={skinFoldData.height}
                onChange={(e) => {
                  handleInputChange(e);
                  updateField('height', e.target.value);
                }}
              />
            </FieldSet>

            <FieldSet>
              <Label>Peso:</Label>
              <Input
                name="weight"
                placeholder="99,9"
                containerStyle={inputStyle.input}
                fontSize="1.5rem"
                type="text"
                value={skinFoldData.weight}
                onChange={(e) => {
                  handleInputChange(e);
                  updateField('weight', e.target.value);
                }}
              />
            </FieldSet>

            <FieldSet>
              <Label>IMC:</Label>
              <Input
                name="imc"
                placeholder="Esperando altura..."
                disabled
                containerStyle={inputStyle.input}
                fontSize="1.5rem"
                value={skinFoldData.imc}
                onChange={(e) => {
                  handleInputChange(e);
                  updateField('imc', e.target.value);
                }}
              />
            </FieldSet>

            <FieldSet>
              <Label>% Fat:</Label>
              <Input
                name="body_fat"
                placeholder="28"
                containerStyle={inputStyle.input}
                fontSize="1.5rem"
                value={skinFoldData.body_fat}
                onChange={(e) => {
                  handleInputChange(e);
                  updateField('body_fat', e.target.value);
                }}
              />
            </FieldSet>

            <FieldSet>
              <Label>Classificação:</Label>
              <Input
                name="classification"
                placeholder="Esperando o IMC..."
                disabled
                containerStyle={inputStyle.input}
                fontSize="1.5rem"
                value={skinFoldData.classification}
                onChange={(e) => {
                  handleInputChange(e);
                  updateField('classification', e.target.value);
                }}
              />
            </FieldSet>

            <FieldSet>
              <Label>Meta de peso:</Label>
              <Input
                name="goal_weight"
                placeholder="75"
                containerStyle={inputStyle.input}
                fontSize="1.5rem"
                value={skinFoldData.goal_weight}
                onChange={(e) => {
                  handleInputChange(e);
                  updateField('goal_weight', e.target.value);
                }}
              />
            </FieldSet>

            <FieldSet>
              <Label>Nível do aluno:</Label>
              <SelectWrapper>
                <Select
                  key={`rerender_key_${defaultStudentLevel.value}`}
                  name="student_level"
                  isSearchable={false}
                  placeholder="Selecione"
                  options={studentLevelOptions}
                  styles={inputStyle.select}
                  defaultValue={defaultStudentLevel}
                  onChange={(e) => {
                    console.log('e:', e);

                    setStudentLevel(e?.value);
                  }}
                />
              </SelectWrapper>
            </FieldSet>

            <FieldSet>
              <Label>Objetivo:</Label>
              <SelectWrapper>
                <Select
                  key={`rerender_key_${defaultObjective.value}`}
                  name="objective"
                  isSearchable={false}
                  placeholder="Selecione"
                  onChange={(e) => setObjective(e?.value)}
                  defaultValue={defaultObjective}
                  options={objectiveOptions}
                  styles={inputStyle.select}
                />
              </SelectWrapper>
            </FieldSet>

            <FieldSet>
              <Label>Frequência:</Label>
              <SelectWrapper>
                <Select
                  key={`rerender_key_${defaultFrequency?.value}`}
                  name="frequency"
                  isSearchable={false}
                  placeholder="Selecione"
                  onChange={(e) => setFrequency(e?.value)}
                  defaultValue={defaultFrequency}
                  options={frequencyOptions}
                  styles={inputStyle.select}
                />
              </SelectWrapper>
            </FieldSet>

            <FieldSet>
              <Label>Tempo disponível:</Label>
              <SelectWrapper>
                <Select
                  key={`rerender_key_${defaultAvailableTime?.value}`}
                  name="available_time"
                  isSearchable={false}
                  placeholder="Selecione"
                  onChange={(e) => setAvailableTime(e?.value)}
                  defaultValue={defaultAvailableTime}
                  options={availableTimeOptions}
                  styles={inputStyle.select}
                />
              </SelectWrapper>
            </FieldSet>

            <FieldSet>
              <Label>Dias da semana:</Label>

              <CheckboxWrapper>{CheckBox}</CheckboxWrapper>
            </FieldSet>

            <FieldSet>
              <Label>Preferência de horário:</Label>
              <SelectWrapper>
                <Select
                  key={`rerender_key_${defaultScheduleTime.value}`}
                  name="time_preference"
                  placeholder="Selecione"
                  onChange={(e) => setScheduleTime(e?.value)}
                  isSearchable={false}
                  options={scheduleOptions}
                  defaultValue={defaultScheduleTime}
                  styles={inputStyle.select}
                />
              </SelectWrapper>
            </FieldSet>
          </FormContainer>

          <FormLineWrapper>
            <TextareaSet>
              <Label>Histórico de saúde:</Label>
              <Textarea
                style={{ fontSize: '14px' }}
                name="health_history"
                placeholder="Prefiro não incluir histórico de saúde"
                containerStyle={inputStyle.textArea}
                value={skinFoldData.health_history}
                onChange={(e) => {
                  // handleInputChange(e as any);
                  updateField('health_history', e.target.value);
                }}
              />
            </TextareaSet>
          </FormLineWrapper>

          <FormLineWrapper>
            <TextareaSet>
              <Label>Histórico de lesão:</Label>
              <Textarea
                style={{ fontSize: '14px' }}
                name="injury_history"
                placeholder="Prefiro não incluir histórico de lesão"
                containerStyle={inputStyle.textArea}
                defaultValue={skinFoldData.injury_history}
                value={skinFoldData.injury_history}
                onChange={(e) => {
                  // handleInputChange(e as any);
                  updateField('injury_history', e.target.value);
                }}
              />
            </TextareaSet>
          </FormLineWrapper>

          <FormLineWrapper>
            <ProfileCodeContainer>
              <Label>Profile Code:</Label>
              <Input
                name="profile_code"
                disabled
                containerStyle={inputStyle.input}
                fontSize="1.5rem"
                value={skinFoldData.profile_code}
              />
            </ProfileCodeContainer>
          </FormLineWrapper>
        </>
      )
    );
  }, [
    skinFoldData,
    CheckBox,
    defaultAvailableTime,
    defaultFrequency,
    defaultObjective,
    defaultScheduleTime,
    defaultStudentLevel,
    selectedComponent,
    handleInputChange,
    updateField,
  ]);

  const renderAnthropometryForm = useCallback(() => {
    return (
      selectedComponent === 'anthropometry' && (
        <>
          <SectionLabel>Circunferências</SectionLabel>

          <FormContainer>
            <FieldSet>
              <Label>Tórax (cm):</Label>
              <Input
                name="circumference_chest"
                defaultValue={skinFoldData.circumference_chest}
                containerStyle={inputStyle.input}
                fontSize="1.5rem"
                onChange={(e) => {
                  handleInputChange(e);
                  updateField('circumference_chest', e.target.value);
                }}
              />
            </FieldSet>

            <FieldSet>
              <Label>Cintura (cm):</Label>
              <Input
                name="circumference_waist"
                containerStyle={inputStyle.input}
                fontSize="1.5rem"
                defaultValue={skinFoldData.circumference_waist}
                onChange={(e) => {
                  handleInputChange(e);
                  updateField('circumference_waist', e.target.value);
                }}
              />
            </FieldSet>

            <FieldSet>
              <Label>Abdomen (cm):</Label>
              <Input
                name="circumference_abdomen"
                containerStyle={inputStyle.input}
                fontSize="1.5rem"
                defaultValue={skinFoldData.circumference_abdomen}
                onChange={(e) => {
                  handleInputChange(e);
                  updateField('circumference_abdomen', e.target.value);
                }}
              />
            </FieldSet>

            <FieldSet>
              <Label>Quadril (cm):</Label>
              <Input
                name="circumference_hip"
                containerStyle={inputStyle.input}
                fontSize="1.5rem"
                defaultValue={skinFoldData.circumference_hip}
                onChange={(e) => {
                  handleInputChange(e);
                  updateField('circumference_hip', e.target.value);
                }}
              />
            </FieldSet>

            <FieldSet>
              <Label>Braço relaxado (cm):</Label>
              <DoubleInputContainer>
                <Input
                  name="circumference_relaxed_arm_left"
                  placeholder="Lado esquerdo"
                  containerStyle={inputStyle.doubleInput}
                  fontSize="1.5rem"
                  defaultValue={skinFoldData.circumference_relaxed_arm_left}
                  onChange={(e) => {
                    handleInputChange(e);
                    updateField(
                      'circumference_relaxed_arm_left',
                      e.target.value,
                    );
                  }}
                />

                <Input
                  name="circumference_relaxed_arm_right"
                  placeholder="Lado direito"
                  containerStyle={inputStyle.doubleInput}
                  fontSize="1.5rem"
                  defaultValue={skinFoldData.circumference_relaxed_arm_right}
                  onChange={(e) => {
                    handleInputChange(e);
                    updateField(
                      'circumference_relaxed_arm_right',
                      e.target.value,
                    );
                  }}
                />
              </DoubleInputContainer>
            </FieldSet>

            <FieldSet>
              <Label>Braço contraído (cm):</Label>
              <DoubleInputContainer>
                <Input
                  name="circumference_contracted_arm_left"
                  placeholder="Lado esquerdo"
                  containerStyle={inputStyle.doubleInput}
                  fontSize="1.5rem"
                  defaultValue={skinFoldData.circumference_contracted_arm_left}
                  onChange={(e) => {
                    handleInputChange(e);
                    updateField(
                      'circumference_contracted_arm_left',
                      e.target.value,
                    );
                  }}
                />
                <Input
                  name="circumference_contracted_arm_right"
                  placeholder="Lado direito"
                  containerStyle={inputStyle.doubleInput}
                  fontSize="1.5rem"
                  defaultValue={skinFoldData.circumference_contracted_arm_right}
                  onChange={(e) => {
                    handleInputChange(e);
                    updateField(
                      'circumference_contracted_arm_right',
                      e.target.value,
                    );
                  }}
                />
              </DoubleInputContainer>
            </FieldSet>

            <FieldSet>
              <Label>Antebraço (cm):</Label>
              <DoubleInputContainer>
                <Input
                  name="circumference_forearm_left"
                  placeholder="Lado esquerdo"
                  containerStyle={inputStyle.doubleInput}
                  fontSize="1.5rem"
                  defaultValue={skinFoldData.circumference_forearm_left}
                  onChange={(e) => {
                    handleInputChange(e);
                    updateField('circumference_forearm_left', e.target.value);
                  }}
                />
                <Input
                  name="circumference_forearm_right"
                  placeholder="Lado direito"
                  containerStyle={inputStyle.doubleInput}
                  fontSize="1.5rem"
                  defaultValue={skinFoldData.circumference_forearm_right}
                  onChange={(e) => {
                    handleInputChange(e);
                    updateField('circumference_forearm_right', e.target.value);
                  }}
                />
              </DoubleInputContainer>
            </FieldSet>

            <FieldSet>
              <Label>Punho (cm):</Label>
              <DoubleInputContainer>
                <Input
                  name="circumference_fist_left"
                  placeholder="Lado esquerdo"
                  containerStyle={inputStyle.doubleInput}
                  fontSize="1.5rem"
                  defaultValue={skinFoldData.circumference_fist_left}
                  onChange={(e) => {
                    handleInputChange(e);
                    updateField('circumference_fist_left', e.target.value);
                  }}
                />
                <Input
                  name="circumference_fist_right"
                  placeholder="Lado direito"
                  containerStyle={inputStyle.doubleInput}
                  fontSize="1.5rem"
                  defaultValue={skinFoldData.circumference_fist_right}
                  onChange={(e) => {
                    handleInputChange(e);
                    updateField('circumference_fist_right', e.target.value);
                  }}
                />
              </DoubleInputContainer>
            </FieldSet>

            <FieldSet>
              <Label>Coxa proximal - prega glútea (cm):</Label>
              <DoubleInputContainer>
                <Input
                  name="circumference_proximal_thigh_left"
                  placeholder="Lado esquerdo"
                  containerStyle={inputStyle.doubleInput}
                  fontSize="1.5rem"
                  defaultValue={skinFoldData.circumference_proximal_thigh_left}
                  onChange={(e) => {
                    handleInputChange(e);
                    updateField(
                      'circumference_proximal_thigh_left',
                      e.target.value,
                    );
                  }}
                />
                <Input
                  name="circumference_proximal_thigh_right"
                  placeholder="Lado direito"
                  containerStyle={inputStyle.doubleInput}
                  fontSize="1.5rem"
                  defaultValue={skinFoldData.circumference_proximal_thigh_right}
                  onChange={(e) => {
                    handleInputChange(e);
                    updateField(
                      'circumference_proximal_thigh_right',
                      e.target.value,
                    );
                  }}
                />
              </DoubleInputContainer>
            </FieldSet>

            <FieldSet>
              <Label>Coxa distal - 10 cm (cm):</Label>
              <DoubleInputContainer>
                <Input
                  name="circumference_distal_thigh_left"
                  placeholder="Lado esquerdo"
                  containerStyle={inputStyle.doubleInput}
                  fontSize="1.5rem"
                  defaultValue={skinFoldData.circumference_distal_thigh_left}
                  onChange={(e) => {
                    handleInputChange(e);
                    updateField(
                      'circumference_distal_thigh_left',
                      e.target.value,
                    );
                  }}
                />
                <Input
                  name="circumference_distal_thigh_right"
                  placeholder="Lado direito"
                  containerStyle={inputStyle.doubleInput}
                  fontSize="1.5rem"
                  defaultValue={skinFoldData.circumference_distal_thigh_right}
                  onChange={(e) => {
                    handleInputChange(e);
                    updateField(
                      'circumference_distal_thigh_right',
                      e.target.value,
                    );
                  }}
                />
              </DoubleInputContainer>
            </FieldSet>

            <FieldSet>
              <Label>Panturrilha (cm):</Label>
              <DoubleInputContainer>
                <Input
                  name="circumference_calf_left"
                  placeholder="Lado esquerdo"
                  containerStyle={inputStyle.doubleInput}
                  fontSize="1.5rem"
                  defaultValue={skinFoldData.circumference_calf_left}
                  onChange={(e) => {
                    handleInputChange(e);
                    updateField('circumference_calf_left', e.target.value);
                  }}
                />
                <Input
                  name="circumference_calf_right"
                  placeholder="Lado direito"
                  containerStyle={inputStyle.doubleInput}
                  fontSize="1.5rem"
                  defaultValue={skinFoldData.circumference_calf_right}
                  onChange={(e) => {
                    handleInputChange(e);
                    updateField('circumference_calf_right', e.target.value);
                  }}
                />
              </DoubleInputContainer>
            </FieldSet>
          </FormContainer>

          {renderSkinFoldSide()}

          {skinFoldSide === 'left' ? (
            <LeftSide data={skinFoldData} />
          ) : (
            <RightSide data={skinFoldData} />
          )}
        </>
      )
    );
  }, [
    skinFoldData,
    handleInputChange,
    renderSkinFoldSide,
    selectedComponent,
    skinFoldSide,
  ]);

  return (
    <Layout title="Aluno">
      <Container>
        <Sidebar>
          <ul>
            {sidebarList.map((item) => (
              <li
                key={item.value}
                onClick={() => setSelectedComponent(item.value)}
                className={selectedComponent === item.value ? 'active' : ''}
              >
                <p>{item.title}</p>
              </li>
            ))}
          </ul>
        </Sidebar>

        <Wrapper>
          <PageHeader>
            <PageHeaderBackButton onClick={() => goBack()}>
              <IoIosArrowBack />
              <PageHeaderBackButtonLabel>
                editar ficha técnica
              </PageHeaderBackButtonLabel>
            </PageHeaderBackButton>

            <PageHeaderSaveButton
              disabled={loading}
              onClick={() => formRef.current?.submitForm()}
            >
              Salvar
            </PageHeaderSaveButton>
          </PageHeader>

          <SessionContainer>
            <Form ref={formRef} onSubmit={handleSubmit}>
              {renderDataSheetForm()}

              {renderAnthropometryForm()}
            </Form>
          </SessionContainer>
        </Wrapper>
      </Container>
    </Layout>
  );
};

export default DataSheetEdit;
